import React, { useState, useContext } from 'react';
import axios from 'axios';
import config from '../config';
import { useNavigate } from 'react-router-dom';
import { getAuth, RecaptchaVerifier, signInWithPhoneNumber, ConfirmationResult } from 'firebase/auth';
import './VerifyForm.css'; // Import the CSS file
import { RoundUpContext } from '../App';
interface VerifyFormProps {
    confirmationResult: ConfirmationResult;
}

const VerifyForm: React.FC<VerifyFormProps> = ({ confirmationResult }) => {
    const [code, setCode] = useState('');
    const [error, setError] = useState<string | null>(null);
    const navigate = useNavigate();
    const isRoundUp = useContext(RoundUpContext);

    const handleSubmit = async (event: React.FormEvent) => {
        event.preventDefault();

        try {
            //console.log('Confirmation with code started'); // log before the confirm function
            const result = await confirmationResult.confirm(code);
            //console.log('Confirmation with code finished', result); // log after the confirm function

            // If the request is successful, redirect to the main page
            if (result.user) {
                // User is signed in
                if (isRoundUp) {
                    // Navigate to main page
                    navigate('/main')

                } else {
                    navigate('/pundit');
                }
            }
        } catch (err) {
            console.error('Failed to verify:', err); // log error if any
            setError('Failed to verify');
        }
    }

    return (
        <form onSubmit={handleSubmit} className="verifyForm">
            <input
                type="text"
                value={code}
                onChange={e => setCode(e.target.value)}
                placeholder="Verification code"
            />
            {error && <p>{error}</p>}
            <button type="submit">Verify</button>
        </form>
    );
}

export default VerifyForm;
